import { Injectable } from "@angular/core";
import { NbAuthStrategyClass, NbOAuth2AuthStrategyOptions, NbPasswordAuthStrategy,NbPasswordAuthStrategyOptions } from '@nebular/auth';
@Injectable()
export class rivenditoreStrategie extends NbPasswordAuthStrategy {
  static setup(options: NbPasswordAuthStrategyOptions): [NbAuthStrategyClass, NbPasswordAuthStrategyOptions] {
    return [rivenditoreStrategie, options]; // HERE we make sure our strategy reutrn correct class reference
  }
}